import styled, { css } from "styled-components";
import { rem } from "polished";

import { ReactComponent as DivideBuyLogo } from "../../assets/img/divide-buy-logo.svg";
import NumberFormat from "../../helpers/number-format";

const DivideBuyEl = styled.p`
	font-size: ${rem(15)};
	font-family: sans-serif;
	font-weight: 400;
	color: #282a2c;
	margin: ${rem(7)} 0;
	display: flex;

	svg {
		width: ${rem(68)};
	}

	${(props) =>
		props.alignRight &&
		css`
			justify-content: flex-end;
		`}
`;

const Container = styled.div`
	a {
		color: #2d71b6;
		font-family: sans-serif;
		font-size: ${rem(15)};
	}
`;

const DivideBuy = ({ totalPrice, alignRight }) => (
	<Container>
		<DivideBuyEl alignRight={alignRight}>
			<DivideBuyLogo />
			&nbsp;- from £{NumberFormat(totalPrice / 8)} p/m, 0% credit
		</DivideBuyEl>
	</Container>
);

export default DivideBuy;
